<div class="table mt-0100"
     *ngIf="entity">

  <!--Menu Button Template-->
  <mat-menu class="popover__menu ignore-click"
            #emailmenu="matMenu">
    <ng-template matMenuContent
                 let-email="email">
      <ng-container *ngIf="isBad(email); then badButtons else goodButtons">
      </ng-container>

      <ng-template #badButtons>
        <button mat-menu-item
                (click)="onSetStatus(email, 'user_added')">
          <span class="link link--green link--noline">Restore</span>
        </button>
      </ng-template>

      <ng-template #goodButtons>
        <button mat-menu-item
                (click)="onEdit(email)">Edit
        </button>
        <button mat-menu-item
                *ngIf="!isVerified(email)"
                (click)="onSetStatus(email, 'verified')">
          <span class="link link--green link--noline">Mark as confirmed</span>
        </button>
        <button mat-menu-item
                *ngIf="isVerified(email)"
                (click)="onSetStatus(email, 'user_added')">
          Unmark as confirmed
        </button>
        <button mat-menu-item
                *ngIf="!email.subscribed"
                (click)="onSetSubscribed(email, true)">
          <span class="link link--green link--noline">Mark as subscribed</span>
        </button>
        <button mat-menu-item
                *ngIf="email.subscribed"
                (click)="onSetSubscribed(email, false)">
          Unmark as subscribed
        </button>


        <mat-divider></mat-divider>
        <button mat-menu-item
                *ngIf="!isDoNotContact(email)"
                (click)="onSetStatus(email, 'do_not_contact')">
          <span class="link link--noline link--red">Mark as do not contact</span>
        </button>
        <button mat-menu-item
                *ngIf="isDoNotContact(email)"
                (click)="onSetStatus(email, 'user_added')">
          Unmark as do not contact
        </button>


        <button mat-menu-item
                (click)="onSetStatus(email, 'bad')">
          <span class="link link--noline link--red"
                data-test-id="markAsBad">Mark as bad</span>
        </button>
      </ng-template>
    </ng-template>
  </mat-menu>

  <div class="tr tr--noGutter tile__heading pt-0 pb-0">
    Email Addresses
    <ng-container *ngIf="showTaskDoneMark">
      <span class="color--gray ml-0050">
        &bull;
        <span class="color--green">
          <span class="d-none d-inline--md uppercase ml-0025">Done</span>
          <i class="far fa-check ml-0025"></i>
        </span>
      </span>
    </ng-container>
    <button mat-button
            *ngIf="!readonly"
            disableRipple
            class="addNew ml-auto mat-button--no-focus-overlay"
            (click)="onAddNew()">
      <i class="far fa-plus addNew__icon"></i>
      Add
    </button>
  </div>

  <div class="tr trContact entity-tr--contact"
       *ngFor="let email of sortByBest(entity.emails, showBad)"
       [ngClass]="{'tr--red': isBad(email)}">
    <div class="tc trContact__title flexAlign-center">
      <a class="link link--black link--noline"
         *ngIf="!isDoNotContact(email)"
         [attr.href]="'mailto:' + email.email"
         title="{{email.email}}">{{email.email}}</a>
      <span class="txt-fw-500 color--gray--007"
            *ngIf="isDoNotContact(email)"
            title="{{email.email}}">{{email.email}}</span>
      <i class="fas fa-ban color--red pair__verified ml-0050"
         *ngIf="isDoNotContact(email)"
         matTooltip="Marked as Do Not Contact"
         matTooltipPosition="above"></i>
      <i class="far fa-times-circle pair__red ml-0050"
         *ngIf="isBad(email)"
         matTooltip="Marked as Bad"
         matTooltipPosition="above"></i>
      <i class="far fa-check pair__verified ml-0050"
         *ngIf="isVerified(email)"
         matTooltip="Confirmed"
         matTooltipPosition="above"></i>
      <i class="far fa-bell-on pair__verified ml-0050"
         *ngIf="email.subscribed"
         matTooltip="Subscribed"
         matTooltipPosition="above"></i>
        <a class="dupe-info-btn ml-0050"
           (click)="onFlagSharedInfoClick(email)"
           matTooltip="This email address is shared by more than one {{entity.entityType.nameSingular}}. Click to view them all."
           *ngIf="isSharedEmail(email.email)">
          <i class="far fa-circle-exclamation"></i>
        </a>
    </div>

    <div class="tc tc--xs trContact__type">{{email.emailType | propercase}}</div>

    <div class="tc tc--xs trContact__type">{{email.source | source}}</div>

    <div class="tc tc--light tc--xs trContact__meta"
         title="{{email.updatedAt|date:'medium'}}">
      Edited {{email.updatedAt | relativeDate}}
    </div>

    <div class="tr__drawer tr__drawer--sm drawer">
      <button class="drawer__btn"
              *ngIf="!readonly"
              type="button"
              [matMenuTriggerFor]="emailmenu"
              [matMenuTriggerData]="{email: email}"
              [attr.data-test-id]="'emailDrawer_' + email.email">
        <i class="far fa-fw fa-ellipsis-h fa--gray"></i>
      </button>
    </div>
  </div>

  <div class="tr tr--noGutter tr--sm tr--gray"
       *ngIf="getBadCount(entity.emails) > 0">
    <div class="addNew addNew--red ml-auto mr-0025"
         (click)="showBad = !showBad"
         data-test-id="toggleEmailShowBad">
      <ng-container *ngIf="!showBad">
        <span class="addNew__text">
          View Bad (<strong data-test-id="emailBadCount">{{getBadCount(entity.emails)}}</strong>)
        </span>
        <i class="far fa-chevron-down ml-0050 addNew__text--gray"></i>
      </ng-container>
      <ng-container *ngIf="showBad">
        <span class="addNew__text">
          Hide Bad (<strong data-test-id="emailBadCount">{{getBadCount(entity.emails)}}</strong>)
        </span>
        <i class="far fa-chevron-up ml-0050 addNew__text--gray"></i>
      </ng-container>
    </div>
  </div>

</div>
